//sent filter api call
export const SEARCH_PAGE_CHECK_REQUEST = "SEARCH_PAGE_CHECK_REQUEST"
export const SEARCH_PAGE_CHECK_REQUEST_SUCCESS = "SEARCH_PAGE_CHECK_REQUEST_SUCCESS"
export const SEARCH_PAGE_CHECK_REQUEST_API_ERROR = "SEARCH_PAGE_CHECK_REQUEST_API_ERROR"
